import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_7ntzgq445b: FaireCollectionEntity = {
  token: "pbc_7ntzgq445b",
  type: "collection",
  name: "Organic Cotton Stuffed Toys & Rattles",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ff81f0c68bace512116f8cce6aec8073512267fb9c117d4375b58b3d22780cad.jpeg",
  itemCount: 26,
  description:
    "Quirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nHeirloom quality, non-toxic and eco-friendly materials.\nEthically handmade by artisans in India.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:18.646Z",
    importedBy: "entity-db-import-collections",
  },
};
